import { ConnectComponent } from "util";
import Presenter from "./presenter";
import View from "./view";

export default ConnectComponent(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/history/sales/data-table/index.jsx